import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { LocationEffect } from "./effect";
import { LocationReducer } from "./reducer";

@NgModule({
    imports: [
        EffectsModule.forFeature([LocationEffect]),
        StoreModule.forFeature('location', LocationReducer)
    ]
})

export class LocationStoreModule { }

export const locationList = (store: any) => store && store.location && store.location.locationList;
export const saveLocationResponse = (store: any) => store && store.location && store.location.saveLocationResponse;
export const deleteLocationResponse = (store: any) => store && store.location && store.location.deleteLocationResponse;
